<!-- components/CryptoEuroPrice.vue -->
<template>
    <component :is="wrapInDiv ? 'div' : 'span'" style="white-space: nowrap;">
        <template v-if="displayLeft">
            <span v-if="!isEuro" class="px-2 small">&euro;&nbsp;{{ formattedEuro }}</span>
            <crypto-price :coin="coin" :price-in-bold="priceInBold" />
        </template>
        <template v-else>
            <crypto-price :coin="coin" :price-in-bold="priceInBold" />
            <span v-if="!isEuro" class="px-2 small">&euro;&nbsp;{{ formattedEuro }}</span>
        </template>
    </component>
</template>



<script>
    import CryptoPrice from './CryptoPrice.vue';

    export default {
        name: "CryptoEuroPrice",
        components: {
            CryptoPrice
        },
        props: {
            coin: {
                type: Object,
                required: true
            },
            wrapInDiv: {
                type: Boolean,
                default: false
            },
            priceInBold: {
                type: Boolean,
                default: false
            },
            displayLeft: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            formattedEuro() {
                return this.coin.amountInEuro.toFixed(2);
            },
            isEuro() {
                return this.coin.currencyCode === 'EUR';
            },
        }
    };
</script>
